import React, { FC } from 'react';
import { Filter, DateInput, TextInput, BooleanInput } from 'react-admin';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core';
import { AppRole } from 'providers/roles';
import { PermissionsProvider } from 'providers/permissionsProvider';
import { SupervisorReferenceInput } from 'components/SupervisorReferenceInput';
import { LazyReferenceInput } from 'components/LazyAutoCompleteInput';

const useStyles = makeStyles({
  filterDate: {
    width: '100%',
    minWidth: '200px',
  },
});

export const TnWarrantyFilters: FC<any> = props => {
  const { hasRole } = PermissionsProvider.useContainer();
  const classes = useStyles();
  const isSupervisor = hasRole(AppRole.Supervisor);

  return (
    <Box>
      <Filter {...props}>
        {!isSupervisor && (
          <SupervisorReferenceInput
            source="supervisorUserIds||$cont"
            alwaysOn
          />
        )}
        <TextInput
          label="Lot"
          source="jobLot||$eq"
          alwaysOn
          resettable
          data-cy="tnWarrantyFilterLot"
        />
        <TextInput
          label="Block"
          source="jobBlock||$eq"
          alwaysOn
          resettable
          data-cy="tnWarrantyFilterBlock"
        />
        <LazyReferenceInput
          label="Builder"
          source="builderId"
          reference="builder"
          resettable
          data-cy="tnWarrantyFilterBuilder"
          alwaysOn
          allowEmpty={false}
          filterToQuery={value => (value ? { name: value } : {})}
          sort={{ field: 'name', order: 'ASC' }}
          optionText="name"
          optionValue="id"
        />
        <LazyReferenceInput
          label="Subdivision"
          source="subdivisionId"
          reference="subdivision"
          resettable
          data-cy="tnWarrantyFilterSubdivision"
          alwaysOn
          allowEmpty={false}
          filterToQuery={value => (value ? { name: value } : {})}
          sort={{ field: 'name', order: 'ASC' }}
          optionText="name"
          optionValue="id"
        />
        <TextInput
          label="Address"
          alwaysOn
          resettable
          source="address1||$cont"
          data-cy="tnWarrantyFilterAddress"
        />
        <DateInput
          className={classes.filterDate}
          label="Warranty Start Date From"
          source="currentPhaseDateApproved||$gte"
          resettable
        />
        <DateInput
          className={classes.filterDate}
          label="Warranty Start Date To"
          source="currentPhaseDateApproved||$lte"
          resettable
        />
        <DateInput
          className={classes.filterDate}
          label="Last Approval Date From"
          source="currentPhaseDateApproved||$gte"
          resettable
        />
        <DateInput
          className={classes.filterDate}
          label="Last Approval Date To"
          source="currentPhaseDateApproved||$lte"
          resettable
        />
        <LazyReferenceInput
          label="Current Contractor"
          source="contractorId"
          reference="contractor"
          data-cy="tnWarrantyFilterContractor"
          sort={{ field: 'name', order: 'ASC' }}
          filterToQuery={value => {
            if (value) {
              return {
                s: {
                  $and: [
                    {
                      name: { $cont: value },
                    },
                  ],
                },
              };
            }
          }}
          allowEmpty={false}
          resettable
          optionText="name"
          optionValue="id"
          suggestionLimit={25}
        />
        <BooleanInput
          source="requestIsOnTime"
          label="Request Is On Time"
          data-cy="tnWarrantyFilterRequestOnTime"
        />
        <BooleanInput
          source="currentPhaseIsOnTime"
          label="Phase On Time"
          data-cy="tnWarrantyFilterPhaseOnTime"
        />
        <BooleanInput
          source="currentPhaseApprovalIsOnTime"
          label="Approval On Time"
          data-cy="tnWarrantyFilterApprovalOnTime"
        />
        <DateInput
          className={classes.filterDate}
          label="Resource Requested On or After"
          source="currentPhaseDateRequested||$gte"
          resettable
        />
        <DateInput
          className={classes.filterDate}
          label="Resource Requested On or Before"
          source="currentPhaseDateRequested||$lte"
          resettable
        />
      </Filter>
    </Box>
  );
};
